import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Categorycard.css'
import { BASE_URL, IMGAGE_URL } from '../../Config';
import { Link } from 'react-router-dom';
import { FaRegEye } from 'react-icons/fa';
import { TbFileInvoice } from 'react-icons/tb';
import { BsArrowReturnRight } from 'react-icons/bs';

// Static data for all categories
const staticData = {
  'Test Series': [
    { id: 101, title: 'UPSC Full Mock Test Series 2025', created_at: '2025-12-15T10:30:00', price: 1499, duration: '6 Months', status: 'Active' },
    { id: 102, title: 'SSC CGL Tier-1 & Tier-2 Package', created_at: '2025-11-20T14:45:00', price: 999, duration: '4 Months', status: 'Active' },
    { id: 103, title: 'Rajasthan REET Level-2 Test Series', created_at: '2025-10-05T09:15:00', price: 799, duration: '3 Months', status: 'Active' },
    { id: 104, title: 'BPSC Combined Competitive Exam Series', created_at: '2025-09-18T16:20:00', price: 1299, duration: '5 Months', status: 'Upcoming' },
    { id: 105, title: 'MPPSC Prelims + Mains Mock Tests', created_at: '2025-08-10T11:00:00', price: 1199, duration: '4 Months', status: 'Active' },
  ],
  'Teachers on Call': [
    { id: 201, title: '1-on-1 UPSC History Doubt Session', created_at: '2025-12-10T13:00:00', price: 499, duration: '60 Min', status: 'Available' },
    { id: 202, title: 'Live GS Polity Teacher Call', created_at: '2025-11-25T15:30:00', price: 399, duration: '45 Min', status: 'Booked' },
    { id: 203, title: 'Current Affairs Expert Consultation', created_at: '2025-10-30T10:45:00', price: 599, duration: '90 Min', status: 'Available' },
  ],
  'Live Classes': [
    { id: 301, title: 'Daily Current Affairs Live Class', created_at: '2025-12-18T08:00:00', price: 0, duration: '60 Min Daily', status: 'Ongoing' },
    { id: 302, title: 'UPSC Ethics GS-4 Batch', created_at: '2025-11-15T12:00:00', price: 4999, duration: '3 Months', status: 'Starting Soon' },
    { id: 303, title: 'SSC Maths Live Crash Course', created_at: '2025-10-20T09:30:00', price: 1999, duration: '2 Months', status: 'Active' },
    { id: 304, title: 'Rajasthan GK Special Live Series', created_at: '2025-09-05T14:00:00', price: 1499, duration: '45 Days', status: 'Active' },
  ],
  'Interviews': [
    { id: 401, title: 'IAS Mock Interview Session 2025', created_at: '2025-12-01T11:00:00', price: 2499, duration: '120 Min', status: 'Scheduled' },
    { id: 402, title: 'State PSC Personality Test Prep', created_at: '2025-11-10T16:00:00', price: 1999, duration: '90 Min', status: 'Available' },
    { id: 403, title: 'DAF Analysis & Mock Interview', created_at: '2025-10-15T10:30:00', price: 1499, duration: '60 Min', status: 'Booked' },
  ],
};
const CategoryCardView = ({ rows, activeButton, handleButtonClick }) => {
  const [dataByCategory, setDataByCategory] = useState({
    'Test Series': [],
    'Teachers on Call': [],
    'Live Classes': [],
    'Interviews': [],
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const userdatatoken = localStorage.getItem('userDatatoken');
  const tokendata = userdatatoken ? `Bearer ${userdatatoken.replace(/"/g, '')}` : '';

  // API endpoints mapping
  const apiEndpoints = {
    'Test Series': `${BASE_URL}order`,
    'Teachers on Call': `${BASE_URL}teacheroncallorders`,
    'Live Classes': `${BASE_URL}liveclassorders`,
    'Interviews': `${BASE_URL}intervieworders`,
  };

  useEffect(() => {
    const fetchAllCategories = async () => {
      setLoading(true);
      setError(null);

      try {
        const requests = Object.entries(apiEndpoints).map(([category, url]) =>
          axios.get(url, {
            headers: {
              Accept: "application/json",
              Authorization: tokendata,
            },
          }).then(res => ({ category, data: res.data.data || [] }))
            .catch(err => ({ category, data: [], error: err }))
        );

        const results = await Promise.all(requests);

        const newData = {};
        results.forEach(({ category, data }) => {
          newData[category] = data.slice(0, 3); // safety: max 3
        });

        setDataByCategory(newData);
      } catch (err) {
        setError('Failed to load data. Please try again later.');
        console.error('API fetch error:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchAllCategories();
  }, [tokendata]); // token change होने पर refetch

  const currentData = dataByCategory[activeButton] || [];

  // CategoryCardView component के अंदर या parent में
  // const filteredRows = staticData[activeButton] || [];
  return (
    <div className="category-cardview-container">
      {/* Tabs / Buttons */}
      <div className="category-cardview-tabs mb-4">
        {['Test Series', 'Teachers on Call', 'Live Classes', 'Interviews'].map((tab) => (
          <button
            key={tab}
            className={`category-cardview-tab ${activeButton === tab ? 'active' : ''}`}
            onClick={() => handleButtonClick(tab)}
          >
            {tab} ({dataByCategory[tab]?.length || 0})
          </button>
        ))}
      </div>

      {/* Cards Grid */}
      {currentData.length === 0 ? (
        <div className="category-cardview-empty">
          No data available for {activeButton}
        </div>
      ) : (
        <div className="category-cardview-grid">
          {currentData.map((row, index) => (
            <div key={index} className="category-cardview-card">
              {/* Card Header */}
              <div className="category-cardview-header">
                <h5 className="category-cardview-title">
                  Order Id: {row.order_number}
                </h5>

              </div>

              {/* Card Body */}
              <div className="category-cardview-body">
                <div className="category-cardview-info">
                  <div>
                    <strong>Transaction ID:</strong> {row.transaction_number || 'N/A'}
                  </div>
                  <div>
                    <strong>Created:</strong> {row.created_at ? new Date(row.created_at).toLocaleDateString() : 'N/A'}
                  </div>
                 
                  {row.payment_method && (
                    <div>
                      <strong>Payment Status:</strong>{' '}
                      {row.payment_method
                        ? row.payment_method.charAt(0).toUpperCase() + row.payment_method.slice(1).toLowerCase()
                        : 'N/A'}
                    </div>
                  )}
                  {row.payment_status && (
                    <div>
                      <strong>Payment Status:</strong>{' '}
                      {row.payment_status
                        ? row.payment_status.charAt(0).toUpperCase() + row.payment_status.slice(1).toLowerCase()
                        : 'N/A'}
                    </div>
                  )}
                </div>

                {/* Actions */}
                {/* <div className="category-cardview-actions">
                  <button className="btn-view">View Details</button>
                 

                </div> */}
                <div className='d-flex justify-content-between ' style={{gap:"10px"}}>
                  <div className="reportCard-actions">
                    <li className="reportCard-action-item" style={{ color: "#000000" }}>


                      Price: ₹{row.order_cost_after_gst}


                    </li>
                  </div>
                  <div className="reportCard-actions">

                    <li className="reportCard-action-item">
                      {activeButton === "Teachers on Call" ? (
                        <Link to={`/teacher-on-call-orderdetail/${row.order_number}`} className="custom-dropdown-item">
                          <FaRegEye style={{ color: "#1ee0ac" }} /> Order Details
                        </Link>
                      ) : (
                        <Link to={`/orderdetail/${row.order_number}`} className="custom-dropdown-item">
                          <FaRegEye style={{ color: "#1ee0ac" }} /> Order Details
                        </Link>
                      )}
                    </li>

                    {/* {row.order_status !== "pending" && row.invoice_url && (
                      <li className="reportCard-action-item">
                        <a
                          href={IMGAGE_URL + row.invoice_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="custom-dropdown-item"
                        >
                          <TbFileInvoice style={{ color: "#dc3545" }} /> Download Invoice
                        </a>
                      </li>
                    )} */}

                    {row.order_type === "Test Series" && row.package_id && (
                      <li className="reportCard-action-item" style={{ fontSize: "1rem" }}>
                        <Link to={`/package-details/${row.package_id}`} className="custom-dropdown-item">
                          <BsArrowReturnRight style={{ color: "#17a2b8" }} /> Go to Package
                        </Link>
                      </li>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CategoryCardView;